const types = {
    UPDATE_BALANCE: 'userUpdateBalance',
    UPDATE_NICK_NAME: 'userUpdateNickName',
    UPDATE_AVATAR: 'userUpdateAvatar',
    UPDATE_NICK_NAME_FAIL: 'userUpdateNickNameFail',
    UPDATE_NICK_NAME_SUCCESS: 'userUpdateNickNameSuccess',
    CLEAR_NICK_NAME_ERROR: 'userClearNickNameError',
    IS_MOBILE: 'userIsMobile',
    SET_DATA: 'userSetData',
}
export default types;